import React from 'react'
import { SimulateDraft } from 'container/SalesOrder/interfaces'

export const messagePlanilhaToast = (string: string) => {
  const arr = string.split('|')
  return (
    <div>
      {arr.map((s) => {
        if (s)
          return (
            <React.Fragment key={s}>
              {s} <br />
            </React.Fragment>
          )
      })}
    </div>
  )
}

export const filterSimulation = (simulation: SimulateDraft) => {
  return {
    ...simulation,
    materiais: simulation.materiais.map((material) => {
      return {
        ...material,
        cores: material.cores.map((cor) => {
          return { ...cor, ds_cor: cor.ds_cor.replace('.', ' ') }
        })
      }
    })
  }
}
